import { BffGenericErrorCode } from '../../../lib/bff-generic-error-codes';

const ErrorCodes = {
  EPZ_OAUTH_ACCESS_DENIED: 'EPZ_OAUTH_ACCESS_DENIED',
  EPZ_ACCESS_FORBIDDEN: 'EPZ_ACCESS_FORBIDDEN',
};

export const PzOauthErrorCodes = { ...ErrorCodes, ...BffGenericErrorCode };
